import legacy from "../../utils/legacy";
// agent, more 은 true false 값으로 그리도록 처리
export const getPhotoUrl = (photoUrl, type) => {
  if (!photoUrl) return "";
  const photos = photoUrl.split("|");

  let src = "";

  if (type == "building") {
    src = "files/sale_photo/72x72_";
  } else if (type == "building_lg") {
    src = "files/sale_photo/";
  } else if (type == "agent") {
    src = "files/user_photo/100x100_";
  }

  for (let i = 0; i < photos.length; i++) {
    return legacy.server_by_hostname("aurora", src) + photos[i];
  }
  return null;
};
